export default __webpack_public_path__ + "static/media/sydansairaala-logo.180bd641.svg";